export interface VideoItem {
  id: string;
  type: 'video';
  title: string;
  summary: string;
  cover: string;
  author: string;
  publishedAt: string;
  category: string;
  tags: string[];
  views: number;
  duration: string;
  videoType: string;
  videoUrl: string;
  body: string[];
}

export const videoList: VideoItem[] = [
  {
    id: 'video-01',
    type: 'video',
    title: '【现场混剪】夏日音乐节高光三分钟',
    summary: '把三天的现场浓缩成三分钟，从日落唱到星空的完整情绪曲线。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20music%20festival%20crowd%20under%20stage%20lights%20at%20sunset%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20soft%20gradient%20background%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=video-cover-01&orientation=landscape',
    author: '一起艹视频组',
    publishedAt: '2026-10-12',
    category: '短视频',
    tags: ['活动', '音乐节', '现场'],
    views: 218000,
    duration: '03:12',
    videoType: '电影剪辑',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4',
    body: [
      '这段混剪记录了三天的音乐节现场，从午后第一支乐队的试音，到深夜舞台最后的返场。',
      '剪辑刻意保留了观众的跟唱与环境声，希望让你隔着屏幕也能感受到那种被音乐包围的现场感。',
      '示例视频仅用于播放器功能演示，正式上线后将替换为平台自有片源（接口待对接）。',
    ],
  },
  {
    id: 'video-02',
    type: 'video',
    title: '【幕后花絮】网剧《星辰之下》片场的一天',
    summary: '跟着摄影组从凌晨四点开工，看一部网剧是如何被一点点拍出来的。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20film%20crew%20with%20camera%20and%20lighting%20equipment%20at%20dawn%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20soft%20gradient%20background%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=video-cover-02&orientation=landscape',
    author: '一起艹幕后',
    publishedAt: '2026-10-11',
    category: '综艺',
    tags: ['影视', '幕后', '花絮'],
    views: 156000,
    duration: '08:45',
    videoType: '综艺',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4',
    body: [
      '凌晨四点，剧组的灯光车已经到场。演员还在化妆，美术组正在做最后的场景微调。',
      '花絮镜头捕捉到了很多正片里看不到的瞬间：一条镜头拍十七条的坚持，以及全组为一束理想光线默默等待的时刻。',
      '示例视频仅用于播放器功能演示，正式上线后将替换为平台自有片源（接口待对接）。',
    ],
  },
  {
    id: 'video-03',
    type: 'video',
    title: '【五分钟解说】科幻电影的美学到底高级在哪',
    summary: '从构图、配色到声音设计，拆解科幻片让人沉浸的视觉逻辑。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20futuristic%20city%20skyline%20with%20geometric%20shapes%20and%20glow%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20soft%20gradient%20background%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=video-cover-03&orientation=landscape',
    author: '镜头语言',
    publishedAt: '2026-10-10',
    category: '短视频',
    tags: ['影视', '解说', '美学'],
    views: 132000,
    duration: '05:20',
    videoType: '电影剪辑',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4',
    body: [
      '科幻电影的高级感，很多时候并不来自特效，而是来自一套克制而统一的视觉系统。',
      '本期解说从三个维度拆解：冷色与暖色的对比、留白式的构图，以及低频音效对压迫感的营造。',
      '示例视频仅用于播放器功能演示，正式上线后将替换为平台自有片源（接口待对接）。',
    ],
  },
  {
    id: 'video-04',
    type: 'video',
    title: '【名场面合集】那些让人笑到打鸣的综艺瞬间',
    summary: '把一整季节目的笑点串起来，一次看个够。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20playful%20tv%20remote%20and%20abstract%20comedy%20symbols%20with%20sparkles%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20soft%20gradient%20background%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=video-cover-04&orientation=landscape',
    author: '一起艹视频组',
    publishedAt: '2026-10-09',
    category: '综艺',
    tags: ['影视', '综艺', '合集'],
    views: 198000,
    duration: '12:08',
    videoType: '综艺',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4',
    body: [
      '这一期合集整理了近一个月里讨论度最高的综艺名场面，按笑点密度重新排了序。',
      '为了保留现场反应，剪辑没有加入过多旁白，而是让画面自己说话。',
      '示例视频仅用于播放器功能演示，正式上线后将替换为平台自有片源（接口待对接）。',
    ],
  },
  {
    id: 'video-05',
    type: 'video',
    title: '【微短剧】都市小剧场：加班夜的一场奇遇',
    summary: '一个关于深夜写字楼的故事，三分钟看完，笑完有点暖。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20cozy%20city%20office%20window%20at%20night%20with%20warm%20lamps%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20soft%20gradient%20background%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=video-cover-05&orientation=landscape',
    author: '小剧场计划',
    publishedAt: '2026-10-08',
    category: '短视频',
    tags: ['影视', '微短剧', '都市'],
    views: 87400,
    duration: '03:40',
    videoType: '短视频',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4',
    body: [
      '故事发生在一栋写字楼的深夜。主角本以为又要独自加班到天亮，却意外遇到了同样没有离开的人。',
      '微短剧用最少的场景和对话，讲完了一个关于「被看见」的小故事。',
      '示例视频仅用于播放器功能演示，正式上线后将替换为平台自有片源（接口待对接）。',
    ],
  },
  {
    id: 'video-06',
    type: 'video',
    title: '【Vlog】独立音乐人的一天，从排练室到Livehouse',
    summary: '用一整天的时间，记录一个还没有「走红」的音乐人如何坚持。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20guitar%20and%20rehearsal%20room%20with%20music%20notes%20floating%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20soft%20gradient%20background%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=video-cover-06&orientation=landscape',
    author: '声音现场',
    publishedAt: '2026-10-07',
    category: '短视频',
    tags: ['活动', '音乐', 'Vlog'],
    views: 64200,
    duration: '09:15',
    videoType: '短视频',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
    body: [
      '早上八点起床写歌，下午在排练室反复打磨编曲，晚上赶去Livehouse做完最后一场演出。',
      '这支Vlog没有剧本，只是把一个普通音乐人的一天原样记录下来。',
      '示例视频仅用于播放器功能演示，正式上线后将替换为平台自有片源（接口待对接）。',
    ],
  },
  {
    id: 'video-07',
    type: 'video',
    title: '【教程】普通人也能拍出电影感的日常Vlog',
    summary: '不需要昂贵设备，掌握三招构图和运镜，画面质感立刻不一样。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20smartphone%20on%20a%20tripod%20with%20framing%20grid%20lines%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20soft%20gradient%20background%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=video-cover-07&orientation=landscape',
    author: '一起艹学堂',
    publishedAt: '2026-10-06',
    category: '短视频',
    tags: ['短视频', '教程', '拍摄'],
    views: 76400,
    duration: '06:30',
    videoType: '短视频',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
    body: [
      '电影感并不等于昂贵设备，更多来自对光线、构图与节奏的理解。',
      '本期教程用手机演示了三种简单但有效的运镜，以及如何利用自然光让画面更通透。',
      '示例视频仅用于播放器功能演示，正式上线后将替换为平台自有片源（接口待对接）。',
    ],
  },
  {
    id: 'video-08',
    type: 'video',
    title: '【年度盘点】十大高燃片段，看到第几个你起鸡皮疙瘩了',
    summary: '把一年里最让人热血沸腾的瞬间剪在一起，一次燃个够。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20cinematic%20explosion%20of%20orange%20light%20rays%20and%20confetti%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20soft%20gradient%20background%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=video-cover-08&orientation=landscape',
    author: '一起艹视频组',
    publishedAt: '2026-10-05',
    category: '电影剪辑',
    tags: ['影视', '盘点', '高燃'],
    views: 245000,
    duration: '07:52',
    videoType: '电影剪辑',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4',
    body: [
      '这一份年度盘点挑选了十个最具冲击力的片段，覆盖电影、剧集与现场演出。',
      '排序综合考虑了镜头语言、音乐配合以及观众的真实反应。',
      '示例视频仅用于播放器功能演示，正式上线后将替换为平台自有片源（接口待对接）。',
    ],
  },
];